import { render, staticRenderFns } from "./Artworks.vue?vue&type=template&id=50b771f9&scoped=true&lang=pug&"
import script from "./Artworks.vue?vue&type=script&lang=js&"
export * from "./Artworks.vue?vue&type=script&lang=js&"
import style0 from "./Artworks.vue?vue&type=style&index=0&id=50b771f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b771f9",
  null
  
)

export default component.exports